// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"64e9befd","787":"0dfb40e7"}[chunkId] + ".chunk.js";
};